// imports section Start
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import {
  Menu as MenuIcon,
  Cached as CachedIcon,
  Delete as DeleteIcon,
  MoreVert as MoreVertIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@mui/icons-material";
import {
  Box,
  Grid,
  Typography,
  Button,
  IconButton,
  TextField,
  Card,
  CardContent,
  Divider,
  MenuItem,
} from "@mui/material";
// import {
//   removeCashierItemFromCart,
//   increaseCashierItemQuantity,
//   decreaseCashierItemQuantity,
//   updateCashierItemQuantity,
//   clearCashierCart,
// } from "../../store/ReduxCashierCartReducer";
import {
  removeCheffItemFromCart,
  clearCheffCart,
  updateCheffItemQuantity,
} from "../../store/ReduxCheffCartReducer";

import { useLocation } from "react-router-dom";
import { BASEURL } from "../../config/Config";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import { ORDER_API_01 } from "../../api/ApiModel";
import {
  CON_ADDON_CODE,
  CON_IS_ADDON,
  CON_DELIVERY_STS,
  CON_STATUS_PENDING,
  CON_IS_CASHIER_NO,
  CON_EMPTY_VALUE,
  CON_VALUE_ZERO,
  CON_IS_CREDIT_NO,
  CON_VALUE_ZERO_ST,
} from "../../utils/sys/Constants";
import { Link } from "react-router-dom";
import useClientIP from "../../utils/common/ClientIP";
import SnackbarMessage from "../../components/common/SnackbarMessage";
import {
  MSG_CASHIER_FAILED,
  MSG_CASHIER_SUCCESS,
} from "../../utils/sys/Messages";
// imports section End

const CheffSummary = () => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const dispatch = useDispatch();
  const clientIP = useClientIP();
  const [quantity, setQuantity] = useState({});
  const cartItems = useSelector((state) => state.cheffCart.items);
  const [billExpanded, setBillExpanded] = React.useState(false);
  const [advanceAmount, setAdvanceAmount] = useState("");
  const [cashTendered, setCashTendered] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Control Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const location = useLocation();
  // const [placedOrderDetails, setPlacedOrderDetails] = useState(
  //   location.state?.placedOrderDetails || []
  // );

  console.log(cartItems);
  const [totals, setTotals] = useState({
    afterchargeamt: 0,
    netgrossamt: 0,
    netamt: 0,
    advanceamt: 0,
    shipping: 0,
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, CATTYPE, USERNAME } =
    SYS_USER.USER_PARAM || {};

  // Handlers start

  // Function to handle numeric inputs (advance and cash tendered)
  const handleNumericInput = (value, setState) => {
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(value)) {
      setState(value);
    }
  };

  const calculateItemTotal = (item) => {
    return item.ITEMRATE * item.quantity;
  };

  const handleToggleBill = () => {
    setBillExpanded((prev) => !prev);
  };
  const handleRemoveFromCart = (itemId) => {
    dispatch(removeCheffItemFromCart(itemId));
  };

  // Filtered items based on the search query
  const filteredItems = cartItems.filter(
    (item) =>
      item.MENUNAME.toLowerCase().includes(searchQuery.toLowerCase()) ||
      String(item.MENUREFCODE).toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleClearSearch = () => {
    setSearchQuery("");
  };

  useEffect(() => {
    // Initialize quantities and recalculate totals whenever cartItems change
    const initialQuantities = {};
    cartItems.forEach((item) => {
      initialQuantities[item.KOTSEQCODE] = item.quantity || 1;
    });
    setQuantity(initialQuantities);
    calculateAndSetTotals(cartItems);
  }, [cartItems]);

  const handleQuantityChange = (itemId, newQuantity) => {
    if (newQuantity < 1) return;
    setQuantity((prev) => ({
      ...prev,
      [itemId]: newQuantity,
    }));
    dispatch(updateCheffItemQuantity({ itemId, quantity: newQuantity }));
  };

  const handleClearCart = () => {
    dispatch(clearCheffCart());
    // setPlacedOrderDetails([]);
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "LKR",
    }).format(price);
  };

  const calculateAndSetTotals = (items) => {
    let newTotals = {
      afterchargeamt: 0,
      netgrossamt: 0,
      netamt: 0,
      advanceamt: 0,
      shipping: 0,
    };
    items.forEach((item) => {
      newTotals.netgrossamt += item.ITEMRATE * item.quantity;
      // Assuming tax and other charges are applied based on your backend logic
    });
    newTotals.afterchargeamt = newTotals.netgrossamt + newTotals.shipping; // Example calculation
    setTotals(newTotals);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const totalUniqueItems = filteredItems.length; // Count of unique items
  const totalQuantity = filteredItems.reduce((total, item) => {
    const itemQuantity =
      quantity[item.KOTSEQCODE] || item.QTY || item.quantity || 1;
    return total + itemQuantity;
  }, 0);
  // Handlers end

  // API calls start
  const handlePlaceOrder = async () => {
    setLoading(true);

    const payload = {
      // Array of order items in dtDetail
      dtDetail: cartItems.map((item, index) => ({
        kotseqcode: index + 1,
        addoncode: CON_ADDON_CODE,
        menucatcode: String(item.MENUCATCODE),
        menucode: String(item.MENUCODE),
        qty: item.quantity,
        rate: item.ITEMRATE,
        amount: item.ITEMRATE,
        remark: String(item.REMARK),
        isaddon: CON_IS_ADDON,
        sts: CON_STATUS_PENDING,
      })),

      dtCharges: [
        {
          ordertypecode: CON_EMPTY_VALUE,
          chargecode: CON_EMPTY_VALUE,
          chargerate: CON_VALUE_ZERO,
          amount: CON_VALUE_ZERO,
        },
      ],

      dtTax: [
        {
          taxpgcode: CON_EMPTY_VALUE,
          compcode: COMPCODE,
          loccode: LOCCODE,
          taxcode: CON_EMPTY_VALUE,
          taxrate: CON_VALUE_ZERO,
          amount: CON_VALUE_ZERO,
        },
      ],

      dtPay: [
        {
          paymode: CON_EMPTY_VALUE,
          clientname: CON_EMPTY_VALUE,
          refno: CON_EMPTY_VALUE,
          bank: CON_EMPTY_VALUE,
          branch: CON_EMPTY_VALUE,
          amount: CON_VALUE_ZERO,
        },
      ],

      dtVoucher: [
        {
          refcode: CON_EMPTY_VALUE,
          vouchercode: CON_EMPTY_VALUE,
          voucherno: CON_EMPTY_VALUE,
          barcode: CON_EMPTY_VALUE,
          amount: CON_VALUE_ZERO,
        },
      ],

      // Main Order Data
      compcode: COMPCODE,
      loccode: LOCCODE,
      restcode: RESTCODE,
      ordercode: CON_EMPTY_VALUE,
      guestordercode: CON_EMPTY_VALUE,
      terminalcode: clientIP,
      paymentcode: CON_EMPTY_VALUE,
      guestrefcode: CON_EMPTY_VALUE,
      tablecode: CON_EMPTY_VALUE,
      orderendate: new Date().toISOString().split("T")[0],
      deliverydate: new Date().toISOString().split("T")[0],
      deliverytime: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
      billamount: String(totals.netgrossamt),
      discount: CON_VALUE_ZERO_ST,
      paidamount: CON_VALUE_ZERO_ST,
      advanceamount: CON_VALUE_ZERO_ST,
      shippingamount: CON_VALUE_ZERO_ST,
      balanceamount: CON_VALUE_ZERO_ST,
      remark: CON_EMPTY_VALUE,
      ordersts: CON_STATUS_PENDING,
      orderdetsts: CON_STATUS_PENDING,
      paymentsts: CON_STATUS_PENDING,
      deliverysts: CON_DELIVERY_STS,
      officername: CON_EMPTY_VALUE,
      enuser: String(USERNAME),
      locdate: new Date().toISOString().split("T")[0],
      roomnocode: CON_EMPTY_VALUE,
      ordertype: CON_EMPTY_VALUE,
      iscashier: CON_IS_CASHIER_NO,
      paymode: CON_EMPTY_VALUE,
      paydate: new Date().toISOString().split("T")[0],
      grossamount: String(totals.netgrossamt),
      giftamount: CON_VALUE_ZERO_ST,
      loyaltyamount: CON_VALUE_ZERO_ST,
      taxamount: CON_VALUE_ZERO_ST,
      cashamount: CON_VALUE_ZERO_ST,
      chequeamount: CON_VALUE_ZERO_ST,
      slipamount: CON_VALUE_ZERO_ST,
      cardamount: CON_VALUE_ZERO_ST,
      discountrate: CON_VALUE_ZERO_ST,
      creditdueamount: CON_VALUE_ZERO_ST,
      adjustamount: CON_VALUE_ZERO_ST,
      iscredit: CON_IS_CREDIT_NO,
    };

    console.log("Order placed payload:", payload);
    try {
      const response = await externalpostApi(ORDER_API_01, payload);
      console.log("Order placed successfully:", response);

      setSnackbarMessage(MSG_CASHIER_SUCCESS);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      // alert("Order placed successfully!");

      // Reset form fields

      // setPaymentDetails({
      //   shippingCharge: "",
      //   advanceAmount: "",
      //   adjustment: "",
      //   cashTendered: "",
      // });
      dispatch(clearCheffCart());

      // Recalculate totals after placing the order
      // setTotals(calculateAndSetTotals());
    } catch (error) {
      console.error("Error placing order:", error);
      // alert("Error placing order. Please try again.");

      setSnackbarMessage(MSG_CASHIER_FAILED);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };
  // API calls end

  return (
    <Grid spacing={0} sx={styles.aside_content}>
      <Grid container sx={styles.aside_content_header}>
        <Grid item xs={12} sm={12} md={7} lg={7} xl={7} sx={styles.left_align}>
          <Typography
            sx={{
              ...theme.typography.h2,
              color: theme.palette.text.primary,
            }}
          >
            Selected Items
            {/* {order?.MENUNAME} */}
          </Typography>
        </Grid>
      </Grid>
      <Box gap={1} pt={2} display={"flex"} alignItems={"center"}>
        <TextField
          id="outlined-search"
          placeholder="Item Name or Item Code"
          type="search"
          size="small"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{ width: "100%" }}
        />

        <IconButton
          size="small"
          sx={styles.cs_summary_refresh_icon}
          aria-label="clear search"
          onClick={handleClearSearch}
        >
          <CachedIcon />
        </IconButton>
      </Box>

      <Divider sx={{ color: "red", pt: 2 }} />

      <Box sx={styles.cs_summary_items_area}>
        {filteredItems.map((item, index) => (
          <Box key={index} sx={{ paddingTop: 2, overflow: "auto" }}>
            <Grid container sx={styles.cs_summary_card_content}>
              <Grid item xs={3}>
                <Typography sx={styles.cs_summary_card_name} component="div">
                  {item.MENUNAME}
                </Typography>
                <Typography sx={styles.cs_summary_card_item_price}>
                  {item.MENUREFCODE}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <TextField
                    type="number"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={
                      quantity[item.KOTSEQCODE] ||
                      item.QTY ||
                      item.quantity ||
                      1
                    }
                    onChange={(e) => {
                      const value = e.target.value;

                      // Restrict the input to numbers only and limit to 3 digits
                      if (/^\d{1,3}$/.test(value)) {
                        handleQuantityChange(
                          item.KOTSEQCODE,
                          parseInt(value, 10)
                        );
                      }
                    }}
                    InputProps={{ inputProps: { min: 1 } }}
                  />
                </Box>
              </Grid>
              <Grid item xs={4} sx={styles.right_align} pr={1}>
                <Typography
                  sx={styles.cs_summary_card_total_price}
                  component="div"
                >
                  {item.ITEMRATE && item.quantity
                    ? formatPrice(calculateItemTotal(item))
                    : formatPrice(item.AMOUNT)}
                </Typography>
              </Grid>

              <Grid item xs={1} sx={styles.right_align}>
                <IconButton
                  sx={styles.cs_cash_delete_icon}
                  aria-label="delete"
                  onClick={() => handleRemoveFromCart(item.KOTSEQCODE)}
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Box>
        ))}
      </Box>

      <Divider />
      {/* Bill Area start */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          right: 0,
          pt: 2,
          padding: "2px 16px 16px 16px",
          background: theme.palette.input_field.fill,
          zIndex: 1000,
        }}
      >
        {/* <Grid item xs={12} sx={styles.text_center}>
          <IconButton
            onClick={handleToggleBill}
            sx={styles.summary_bill_expand_icon}
          >
            {billExpanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </IconButton>
        </Grid> */}

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between", pt: 2 }}
        >
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            Currency
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            LKR
          </Typography>
        </Grid>

        {[
          {
            description: "Line Items",
            value: `${totalUniqueItems} (Items ${totalQuantity})`,
          },
          { description: "Net Amount", value: formatPrice(totals.netgrossamt) },
          ...(billExpanded
            ? [
                // {
                //   description: "Gross",
                //   value: formatPrice(totals.netgrossamt),
                // },
                // { description: "Discount", value: "0.00" },
                // { description: "Tax", value: "0.00" },
                // { description: "Other Charges", value: "0.00" },
                // {
                //   description: "Cash Paid",
                //   value: formatPrice(totals.netgrossamt),
                // },
                // {
                //   description: "Total Paid",
                //   value: formatPrice(totals.netgrossamt),
                // },
                // { description: "Balance", value: "0.00" },
              ]
            : []),
        ].map((item, index) => (
          <Grid container sx={styles.cs_summary_bill} key={index}>
            <Grid item xs={6} md={6} sx={styles.left_align}>
              <Typography sx={styles.cs_summary_description}>
                {item.description}
              </Typography>
            </Grid>

            <Grid item xs={6} md={6} sx={styles.right_align}>
              {item.input ? (
                <Grid
                  container
                  alignItems="center"
                  sx={styles.right_align}
                ></Grid>
              ) : (
                <Typography sx={styles.cs_summary_price}>
                  {item.value}
                </Typography>
              )}
            </Grid>
          </Grid>
        ))}

        <Grid gap={2} sx={styles.btn_group_bootom_align} pt={2}>
          <Button
            sx={styles.btn_secondary}
            onClick={handlePlaceOrder}
            size="medium"
            variant="outlined"
          >
            Place Order
          </Button>

          <Button
            variant="contained"
            onClick={handleClearCart}
            fullWidth
            size="medium"
            sx={styles.btn_primary}
          >
            New Order
          </Button>
        </Grid>
      </Box>

      {/* Bill Area end */}

      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity} // Dynamic severity (success or error)
      />
    </Grid>
  );
};

export default CheffSummary;
